import { create } from "zustand";

export type Theme = "dark" | "light";

const STORAGE_KEY = "deleggate.theme";

function readInitial(): Theme {
  if (typeof window === "undefined") return "dark";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  return saved === "light" ? "light" : "dark"; // dark-first
}

function apply(theme: Theme) {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.style.colorScheme = theme;
}

interface ThemeState {
  theme: Theme;
  toggle: () => void;
  set: (t: Theme) => void;
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: readInitial(),
  toggle: () => get().set(get().theme === "dark" ? "light" : "dark"),
  set: (theme) => {
    apply(theme);
    window.localStorage.setItem(STORAGE_KEY, theme);
    set({ theme });
  },
}));

// Apply the persisted theme to <html> as soon as the module loads so there is
// no flash. index.html ships with class="dark"; this reconciles a saved choice.
if (typeof window !== "undefined") {
  apply(useTheme.getState().theme);
}
